<dx-data-grid
  (onRowRemoved)="dataChanged.emit()"
  (onSaving)="dataChanged.emit()"
  [columnAutoWidth]="true"
  [dataSource]="selectedMetrics"
  [repaintChangesOnly]="true"
  [height]="'100%'"
  [keyExpr]="'alias'"
  [showBorders]="true"
  [showColumnLines]="false"
  [showRowLines]="false"
  [wordWrapEnabled]="true">
  <dxo-row-dragging
    [allowReordering]="true"
    [dragDirection]="'vertical'"
    [onReorder]="reorderItem"
    [showDragIcons]="true"
  ></dxo-row-dragging>
  <dxo-scrolling
    mode="standard">
  </dxo-scrolling>
  <dxo-editing
    [allowDeleting]="true"
    [allowUpdating]="true"
    [confirmDelete]="false"
    [enabled]="true"
    [mode]="'cell'"
    [startEditAction]="'click'"
    [useIcons]="true">
  </dxo-editing>

  <dxi-column [allowEditing]="false" [dataField]="'partitionName'" [editCellTemplate]="'disabledCellEditTemplate'"
              [showEditorAlways]="true" [width]="'20pc'"
              caption="{{'CHART_CREATION.PARTITION' | translate}}"></dxi-column>
  <dxi-column [allowEditing]="false" [dataField]="'deviceName'" [editCellTemplate]="'disabledCellEditTemplate'"
              [showEditorAlways]="true" caption="{{'CHART_CREATION.DEVICE' | translate}}"></dxi-column>
  <dxi-column [allowEditing]="false" [dataField]="'name'" [editCellTemplate]="'disabledCellEditTemplate'"
              [showEditorAlways]="true" [width]="'20pc'"
              caption="{{'CHART_CREATION.NAME' | translate}}"></dxi-column>
  <dxi-column [allowEditing]="false" [dataField]="'dataUnit'"
              [editCellTemplate]="'disabledCellEditTemplate'" [showEditorAlways]="true"
              caption="{{'CHART_CREATION.DATA_UNIT_SYMBOL' | translate}}"></dxi-column>
  <div *dxTemplate="let cellInfo of 'disabledCellEditTemplate'" style="color: darkgray; padding: 10px 11px;">
    {{ cellInfo.value }}
  </div>

  <dxi-column [showEditorAlways]="true" [editCellTemplate]="'colorBoxCellTemplate'" cssClass="noPaddingCell"
              [dataField]="'color'" caption="{{'CHART_CREATION.COLOR' | translate}}">
    <div *dxTemplate="let cellInfo of 'colorBoxCellTemplate'">
      <dx-lookup
        class="noPaddingCell"
        [value]="cellInfo.value"
        (onValueChanged)="setSelectorValue($event,cellInfo)"
        [dataSource]="gmService.BASE_COLORS"
        [fieldTemplate]="'fieldTemplate'"
        [itemTemplate]="'colorTemplate'"
        [focusStateEnabled]="false"
        [searchEnabled]="false">
        <dxo-drop-down-options
          [hideOnOutsideClick]="true"
          [showTitle]="false"
          [toolbarItems]="[]"
          [width]="250"
          [height]="'auto'"
          [wrapperAttr]="{
          class: 'matrixList'
        }">
        </dxo-drop-down-options>
        <div *dxTemplate="let color of 'colorTemplate'" style="width: min-content">
          <div [style.background-color]="color"
               style="height: 30px; width: 30px; border-radius: 50%"></div>
        </div>
        <div *dxTemplate="let color of 'fieldTemplate'">
          <div style="display: flex; flex-direction: row; align-items: center">
            <div [style.background-color]="color"
                 style="min-height: 30px; min-width: 30px; border-radius: 50%"></div>
            <dx-text-box [disabled]="true" [style.opacity]="0" style="display:inline-block"></dx-text-box>
          </div>
        </div>
      </dx-lookup>
    </div>
  </dxi-column>

  <dxi-column
    [editCellTemplate]="'chartTypeSelector'"
    [dataField]="'chartType'"
    [showEditorAlways]="true"
    caption="{{'CHART_CREATION.CHART_TYPE' | translate}}">
    <div *dxTemplate="let chartType of 'chartTypeSelector'">
      <dx-select-box
        (onValueChanged)="setSelectorValue($event, chartType)"
        class="noPaddingCell"
        [value]="chartType.value"
        [displayExpr]="parseChartType"
        [dataSource]="chartTypes">
      </dx-select-box>
    </div>
  </dxi-column>
  <dxi-column
    [editCellTemplate]="'functionTypeSelector'"
    [dataField]="'functionType'"
    [showEditorAlways]="true"
    caption="{{'CHART_CREATION.FUNCTION_TYPE' | translate}}">
    <div *dxTemplate="let functionType of 'functionTypeSelector'">
      <dx-select-box
        (onValueChanged)="setSelectorValue($event, functionType)"
        class="noPaddingCell"
        [value]="functionType.value"
        [displayExpr]="translateFunctionType"
        [dataSource]="functionTypesValues">
      </dx-select-box>
    </div>
  </dxi-column>

</dx-data-grid>
